import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MistService } from '@app/features/mists/shared/mist.service';
import { Mist } from '@app/shared/models/mist/mist.model';

@Component({
    selector: 'app-wifi-health',
    templateUrl: './wifi-health.component.html',
    styleUrls: ['./wifi-health.component.css'],
    standalone: false
})
export class WifiHealthComponent implements OnInit, OnDestroy {

  isLoading: boolean;
  storeNumber: string = '';
  mists: any[] = [];
  expandedAps: Record<number, boolean> = {};
  allApsExpanded = false;

  constructor(
    private mistService: MistService,
    private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe(params => {
      if ('storeNumber' in params) {
        this.storeNumber = params['storeNumber'];
        this.getWifiHealth();
      }
    });
  }

  ngOnInit() {
    this.storeNumber = localStorage.getItem('storeNumber');
  }

  ngOnDestroy() { }

  getWifiHealth() {
    localStorage.setItem('storeNumber', this.storeNumber);
    this.isLoading = true;
    this.resetView();
    Promise.all(
      [
        this.getMists()
      ]
    ).then(() => {
      this.isLoading = false;
    })
  }

  getMists() {
    const promise = new Promise((resolve, reject) => {
      this.mistService.getAccessPointStats(this.storeNumber).then(response => {
        response.toPromise().then(mists_from_response => {
          try {
            mists_from_response["message"].forEach(mist_json => {
              let mist = mist_json;
              this.mists.push(mist);
            });
          } catch (error) {
            console.log("Mists timed out!")
          } finally {
            resolve(true);
          }
        });
      });
    });

    return promise;
  }

  getColorCpuTemp(cpuTemp) {

    return 'green'
    if (cpuTemp > 75 || cpuTemp < -5) {
      return 'red'
    } else if (cpuTemp > 65 || cpuTemp < 5) {
      return 'orange'
    } else {
      return 'green'
    }

  }

  toggleAp(index: number) {
    this.expandedAps[index] = !this.expandedAps[index];
  }

  expandAllAps() {
    this.allApsExpanded = true;
    this.mists.forEach((_, i) => (this.expandedAps[i] = true));
  }

  collapseAllAps() {
    this.allApsExpanded = false;
    this.expandedAps = {};
  }

  get onlineApCount(): number {
    return this.mists.filter(mist => mist.status === 'connected').length;
  }

  getMistHealthSummary(): string {
    return `${this.onlineApCount}/${this.mists.length} online`;
  }

  isAllApsHealthy(): boolean {
    return this.mists.length > 0 && this.onlineApCount === this.mists.length;
  }

  getApSeverity(): 'green' | 'yellow' | 'red' | 'neutral' {
    if (this.mists.length === 0) return 'neutral';
    if (this.onlineApCount === this.mists.length) return 'green';
    if (this.onlineApCount === 0) return 'red';
    return 'yellow';
  }

  resetView() {
    this.mists = [];
    this.expandedAps = {};
    this.allApsExpanded = false;
  }
}